import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import OutlineMail from 'react-md-icon/dist/OutlineMail';
import { Tooltip } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import './SendButton.scss';

class SendButton extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isTooltipOpen: false,
    };

    this.toggleTooltip = this.toggleTooltip.bind(this);
  }

  toggleTooltip() {
    this.setState({ isTooltipOpen: !this.state.isTooltipOpen });
  }

  render() {
    const {
      onClick,
      uniqueId,
      id,
      showButton,
      isDisabled,
      tooltipText,
    } = this.props;
    return (
      <Fragment>
        <button
          className={`btn btn-send ${!showButton ? 'invisible' : ''} ${isDisabled ? 'btn-send-disabled' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            // using disabled={isDisabled} will prevent the hover effect AND the stopPropagation,
            // both of which we want, so instead we can just disable the onClick
            if (!isDisabled) onClick();
            }}
          id={`${uniqueId}-${id}`}
        >
          <OutlineMail style={{ fontSize: '1.5rem' }} />
        </button>
        {tooltipText ?
          <Tooltip
            placement="bottom"
            isOpen={this.state.isTooltipOpen}
            target={`${uniqueId}-${id}`}
            container="#asure-react-app"
            toggle={this.toggleTooltip}
          >
            <FormattedMessage id={tooltipText} />
          </Tooltip>
        :
          null
        }
      </Fragment>
    );
  }
}

SendButton.defaultProps = {
  id: null,
  isDisabled: false,
  tooltipText: null,
};

SendButton.propTypes = {
  tooltipText: PropTypes.string,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  uniqueId: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  showButton: PropTypes.bool.isRequired,
};

export default SendButton;



// WEBPACK FOOTER //
// ./src/components/SendButton/SendButton.jsx